var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"empty-status"}},[_c('img',{attrs:{"src":_vm.$remoteImg('/earn_coins/no_feed.png')}}),_c('p',[_vm._v("No feeds fetched, please try again later.")])])}
var staticRenderFns = []

export { render, staticRenderFns }